import { ApiErrorCode, ApiResponse, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import { mapFormulaEntry } from '../mappers/formula-library.mapper';
import { FormulaLibraryEntry } from '../types';
import { FormulaLibraryEntryResponse } from '../types/dto';

export const listFormulaEntries = async (reportType?: string): Promise<FormulaLibraryEntry[]> => {
  const endpoint = '/api/formula-library';
  const data = await withApiErrorHandler(endpoint, ApiErrorCode.FORMULA_ENTRIES_LOAD_FAILED, () =>
    axiosInstance.get<ApiResponse<FormulaLibraryEntryResponse[]>>(endpoint, {
      params: reportType ? { reportType } : undefined,
    })
  );
  return data.map(mapFormulaEntry);
};

export const createFormulaEntry = async (body: {
  scope: 'USER' | 'ORG';
  key: string;
  label: string;
  formulaString: string;
  dependsOn: string[];
  measureType: string;
}): Promise<FormulaLibraryEntry> => {
  const endpoint = '/api/formula-library';
  const data = await withApiErrorHandler(endpoint, ApiErrorCode.FORMULA_ENTRY_CREATE_FAILED, () =>
    axiosInstance.post<ApiResponse<FormulaLibraryEntryResponse>>(endpoint, body)
  );
  return mapFormulaEntry(data);
};

export const updateFormulaEntry = async (
  id: string,
  body: Partial<{
    label: string;
    formulaString: string;
    dependsOn: string[];
  }>
): Promise<FormulaLibraryEntry> => {
  const endpoint = `/api/formula-library/${id}`;
  const data = await withApiErrorHandler(endpoint, ApiErrorCode.FORMULA_ENTRY_UPDATE_FAILED, () =>
    axiosInstance.patch<ApiResponse<FormulaLibraryEntryResponse>>(endpoint, body)
  );
  return mapFormulaEntry(data);
};

export const deleteFormulaEntry = async (id: string): Promise<void> => {
  const endpoint = `/api/formula-library/${id}`;
  await withApiErrorHandler(endpoint, ApiErrorCode.FORMULA_ENTRY_DELETE_FAILED, () =>
    axiosInstance.delete<ApiResponse<Record<string, never>>>(endpoint)
  );
};

export const copyFormulaEntry = async (
  id: string,
  scope: 'ORG' | 'USER'
): Promise<FormulaLibraryEntry> => {
  const endpoint = `/api/formula-library/${id}/copy`;
  const data = await withApiErrorHandler(endpoint, ApiErrorCode.GENERIC_ERROR, () =>
    axiosInstance.post<ApiResponse<FormulaLibraryEntryResponse>>(endpoint, undefined, {
      params: { scope },
    })
  );
  return mapFormulaEntry(data);
};
